import { render } from "./Impact_Assessment_by.vue?vue&type=template&id=130b4fad&scoped=true"
import script from "./Impact_Assessment_by.vue?vue&type=script&lang=js"
export * from "./Impact_Assessment_by.vue?vue&type=script&lang=js"

import "./Impact_Assessment_by.vue?vue&type=style&index=0&id=130b4fad&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130b4fad"]])

export default __exports__